import SearchBlock from '@helsenorge/core-cms/search-v2/block';
import { selectCurrentLanguage } from '@helsenorge/framework-utils/language';

import { useGetForsideQuery } from '../store/contentApi';
import { useAppSelector } from '../store/hooks';

const SearchBlockContainer: React.FC = () => {
  const language = useAppSelector(state => selectCurrentLanguage(state.language));
  const { data: forside } = useGetForsideQuery(language);

  if (!forside) {
    return null;
  }

  return (
    <SearchBlock
      title={forside.search.title}
      searchUrl={forside.search.searchUrl}
      link={forside.search.linkUrl}
      linkText={forside.search.linkText}
      imageUrl={forside.search.imageUrl}
      imageAltText={forside.search.imageAltText}
      inputAriaLabel={forside.search.searchLabel}
      containerAriaLabel={forside.search.containerAriaLabel}
      submitButtonText={forside.search.submitButtonText}
      enableAutosuggest={forside.search.enableAutosuggest}
      wrapper
    />
  );
};

export default SearchBlockContainer;
